import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import { withTranslation } from 'react-i18next';

import { Accordion } from '../../Base';

import DownloadableItemWrapper from './DownloadableItemWrapper';

const DownloadableContent = ({ loading, allMaterials, relevantMaterials, onDownloadClick, t }) => {
  const { colors, space } = useTheme();
  const accordionSummaryStylesProps = {
    padding: `0 ${space[5]}px`,
    borderBottom: `1px solid ${colors.greyscale.grey5}`,
  };

  return (
    <Fragment>
      <Accordion
        title={t('COURSE_DOCUMENT_PANEL.TAB.TAB_1.RELEVANT_MATERIAL_LABEL')}
        accordionProps={{ defaultExpanded: true }}
        accordionSummaryStylesProps={accordionSummaryStylesProps}
      >
        <DownloadableItemWrapper
          materials={relevantMaterials}
          onDownloadClick={onDownloadClick}
          noMaterialMessage={t('COURSE_DOCUMENT_PANEL.TAB.TAB_1.NO_RELEVANT_MATERIAL')}
        />
      </Accordion>
      {!loading && (
        <Accordion
          title={t('COURSE_DOCUMENT_PANEL.TAB.TAB_1.OTHER_MATERIAL_LABEL')}
          accordionProps={{ defaultExpanded: true }}
          accordionSummaryStylesProps={accordionSummaryStylesProps}
        >
          <DownloadableItemWrapper
            materials={allMaterials}
            onDownloadClick={onDownloadClick}
            noMaterialMessage={t('COURSE_DOCUMENT_PANEL.TAB.TAB_1.NO_OTHER_MATERIAL')}
          />
        </Accordion>
      )}
    </Fragment>
  );
};

DownloadableContent.propTypes = {
  loading: PropTypes.bool,
  allMaterials: PropTypes.arrayOf(PropTypes.object),
  relevantMaterials: PropTypes.arrayOf(PropTypes.object),
  onDownloadClick: PropTypes.func,
};

DownloadableContent.defaultProps = {
  loading: true,
  allMaterials: [],
  relevantMaterials: [],
  onDownloadClick: () => {},
};

export default withTranslation('classroom')(DownloadableContent);
